(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    var resizeTimer;

    function reflowDesktopHorizontalOverflow() {
      if (window.innerWidth < 750) return;
      const overflowLists = document.querySelectorAll('.facets--horizontal overflow-list.mobile\\:hidden');
      overflowLists.forEach(function (list) {
        // Recalculate overflow after layout has stabilized.
        requestAnimationFrame(function () {
          list.dispatchEvent(new CustomEvent('reflow', { bubbles: true }));
        });
      });
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(reflowDesktopHorizontalOverflow, 120);
    }

    window.addEventListener('resize', onResize, { passive: true });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reflowDesktopHorizontalOverflow);
    } else {
      reflowDesktopHorizontalOverflow();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
